export default __webpack_public_path__ + "static/media/image25.dcd79b5c.jpg";